import React from 'react';

import { Box } from '@atlaskit/primitives';
import { cssMap } from '@atlaskit/css';

import { ContentSourcesPicker } from '../sub-components/content-sources-picker/ContentSourcesPicker';
import type { ActiveAudioContent } from '../../../types/activeAudioContent';

const styles = cssMap({
	container: {
		// arbitrary placeholder
		minHeight: '200px',
	},
});

export const AudioBriefingPopupSourcesPanel = () => {
	const onContentSourcesPickerChange = (_: readonly ActiveAudioContent[]) => {
		// TODO: implement
	};

	return (
		<Box xcss={styles.container}>
			<ContentSourcesPicker onChange={onContentSourcesPickerChange} />
		</Box>
	);
};
